module.exports = __webpack_public_path__ + "static/morneau-logo-c1bd4fa0ca3be292e26b1d64e395693b.png";